/* <variant-picker> — resolves the selected variant, updates the hidden id,
   URL, price + buy button (via the Section Rendering API so money stays
   server-rendered), media, and flips the page --glow to the colourway. */
class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.section = this.dataset.section;
    this.url = this.dataset.url;
    try {
      this.variants = JSON.parse(this.querySelector("[data-variant-json]")?.textContent || "[]");
    } catch (e) {
      this.variants = [];
    }
    this.addEventListener("change", () => this.onChange());
  }

  get form() {
    return document.getElementById(`product-form-${this.section}`);
  }

  selectedOptions() {
    return Array.from(this.querySelectorAll(".variant-picker__fieldset")).map((fs) => {
      const checked = fs.querySelector("input:checked");
      const label = fs.querySelector("[data-selected-value]");
      if (label && checked) label.textContent = checked.value;
      return checked ? checked.value : null;
    });
  }

  onChange() {
    const opts = this.selectedOptions();
    const variant = this.variants.find(
      (v) => v.options.length === opts.length && v.options.every((o, i) => o === opts[i])
    );

    this.flipGlow();

    if (!variant) {
      this.setUnavailable();
      return;
    }

    const hidden = this.form?.querySelector("[data-variant-id]");
    if (hidden) {
      hidden.value = variant.id;
      hidden.removeAttribute("disabled");
    }

    const u = new URL(window.location.href);
    u.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", u);

    this.closest("[data-product-section]")?.dispatchEvent(
      new CustomEvent("variant:change", { detail: { variant } })
    );

    this.renderSection(variant.id);
  }

  flipGlow() {
    const color = this.querySelector("input[data-glow]:checked");
    const map = { purple: "--glow-purple", red: "--glow-red", green: "--glow-green" };
    const section = this.closest("[data-product-section]");
    if (color && section && map[color.dataset.glow]) {
      section.style.setProperty("--glow", `var(${map[color.dataset.glow]})`);
    }
  }

  renderSection(variantId) {
    fetch(`${this.url}?variant=${variantId}&section_id=${this.section}`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        [`#price-${this.section}`, `#buy-${this.section}`].forEach((sel) => {
          const incoming = doc.querySelector(sel);
          const current = document.querySelector(sel);
          if (incoming && current) current.innerHTML = incoming.innerHTML;
        });
        const stickyPrice = document.querySelector(".sticky-atc__price");
        const incomingPrice = doc.querySelector(`#price-${this.section}`);
        if (stickyPrice && incomingPrice) stickyPrice.innerHTML = incomingPrice.innerHTML;
      })
      .catch(() => {});
  }

  setUnavailable() {
    const btn = this.form?.querySelector(".product-form__submit");
    const txt = btn?.querySelector(".product-form__submit-text");
    if (btn) btn.setAttribute("disabled", "");
    if (txt) txt.textContent = txt.dataset.unavailable || "Unavailable";
  }
}
if (!customElements.get("variant-picker")) customElements.define("variant-picker", VariantPicker);
